// React imports.
import React, { Component } from "react";

// App imports.
import { AppPagesEnum } from "../state";

const StartPage = ({ state }) => (
     <React.Fragment>
          The LIHEAP Data Warehouse allows users to access historic national and state-level LIHEAP data to
          build instant reports, tables, and charts. Users can access data through three different options:
          the Grant Recipient Profiles tool, Standard Reports tool, and Custom Reports tool. Resources and tutorials
          to aid users in utilizing these tools are provided below.

          <div className="accordion md-accordion" id="accordionEx" role="tablist" aria-multiselectable="true">

               <div className="card mt-3">
                    <div className="card-header" role="tab" id="heading1">
                         <a data-toggle="collapse" data-parent="#accordionEx" href="#collapse1" aria-expanded="true" aria-controls="collapse1">
                              <h5 className="mb-0">
                                   Grant Recipient Profiles &mdash; One-page snapshots of state LIHEAP Programs. <i className="fas fa-angle-down rotate-icon"></i>
                              </h5>
                         </a>
                    </div>
                    <div id="collapse1" className="collapse" role="tabpanel" aria-labelledby="heading1" data-parent="#accordionEx">
                         <div className="card-body">
                              Choose a year:
                              <br />
                              <select className="form-control" style={{ width: "30%" }} id="GranteeProfileSelectedYear" defaultValue={state.GranteeProfileSelectedYear} onChange={state.granteeProfileSelectedYearFieldChangeHandler}>
                                   <option >Choose a year</option>
                                   
                                   {state.GranteeProfileYears.map(py => {
                                        return (
                                             <option selected={py.fiscalYear === state.GranteeProfileSelectedYear} key={py.fiscalYear} value={py.fiscalYear}>{py.fiscalYear}</option>
                                        );
                                   })}
                              </select>
                              <br /><br />
                              {state.GranteeProfileSelectedYear !== null &&
                                   <div style={{ width: "100%" }} >
                                        Choose a state:
                                        <br />
                                        <select className="form-control" style={{ width: "30%" }} id="GranteeProfile" defaultValue={state.GranteeProfile} onChange={state.granteeProfileSelectedGranteeFieldChangeHandler}>
                                             <option >Choose a state</option>
                                             {state.Grantees.map(grantee => {
                                                  <option value="US">All States (National)</option>
                                                  return (
                                                       <option key={grantee.granteeId} value={grantee.granteeAbbreviation}>{grantee.granteeName}</option>
                                                  );
                                             })}
                                        </select>
                                   </div>
                              }
                              *The presented data for fiscal years 2023 and 2024 should be considered preliminary pending final data validation.


                         </div>
                    </div>
               </div>
               <div className="card mt-3">
                    <div className="card-header" role="tab" id="headingTwo2">
                         <a href="#" onClick={clickEvent => { clickEvent.preventDefault(); state.navigateClickHandler(AppPagesEnum.StandardReports); }}>
                              <h5 className="mb-0">
                                   Standard Reports &mdash; Receive step-by-step guidance on creating reports.
                              </h5>
                         </a>
                    </div>
               </div>
               <div className="card mt-3">
                    <div className="card-header" role="tab" id="headingTwo2">
                         <a href="/datawarehouse/custom_reports">
                              <h5 className="mb-0">
                                   Custom Reports &mdash; Generate customized reports and figures.
                              </h5>
                         </a>
                    </div>
               </div>
               <div className="card mt-3">
                    <div className="card-header" role="tab" id="heading2">
                         <a data-toggle="collapse" data-parent="#accordionEx" href="#collapse2" aria-expanded="true" aria-controls="collapse2">
                              <h5 className="mb-0">
                                   Resources and Tutorial &mdash; Information on the Data Warehouse and its uses.<i className="fas fa-angle-down rotate-icon"></i>
                              </h5>
                         </a>
                    </div>
                    <div id="collapse2" className="collapse" role="tabpanel" aria-labelledby="heading2" data-parent="#accordionEx">
                         <div className="card-body">
                              <a href="/data_warehouse/doc/tutorial.pdf" target="_blank">LIHEAP Data Warehouse Tutorial</a> - PDF Document<br />
                              Step-by-step guidance on using the Data Warehouse.
                              <br /><br />
                              <a href="/data_warehouse/doc/LIHEAP_PM_Glossary.pdf" target="_blank">LIHEAP Glossary</a> - PDF Document<br />
                              Detailed definitions of LIHEAP terms.
                              <br /><br />
                              <a href="/DW-tutorial-supplements">Data Inventory Documents</a><br />
                              An inventory of all data elements included in the Data Warehouse.
                              <br /><br />
                              <a href="/required-reports/" className="guidedSearchOrientation">Background on LIHEAP Data Collection and Reporting</a><br />
                              Explore resources related to data collection and reporting.
                              <br /><br />
                              <a href="/eligibility-methodology">Methodology and Sources Used to Develop LIHEAP Income Eligible Population Estimates</a><br />
                              Learn about how the LIHEAP Income Eligible Population statistics are calculated.
                         </div>
                    </div>
               </div>
          </div>
     </React.Fragment >
);

export default StartPage;
